import * as THREE from 'three';

/** Slow idle orbit around the diorama — this is a viewing camera, not a player-follow rig. */
export class CameraRig {
  private angle = 0;
  private frozen = false;

  constructor(
    private readonly camera: THREE.PerspectiveCamera,
    private readonly center = new THREE.Vector3(0, 0, -0.5),
    private readonly radius = 13,
    private readonly height = 9,
    private readonly angularSpeed = 0.05,
  ) {
    this.snap();
  }

  private snap(): void {
    this.camera.position.set(this.center.x, this.height, this.center.z + this.radius);
    this.camera.lookAt(this.center);
  }

  /** Jumps to the angle=0 pose — the same framing the rig starts in, already verified on-screen. */
  snapToSortView(): void {
    this.angle = 0;
    this.snap();
  }

  freeze(): void {
    this.frozen = true;
  }

  resume(): void {
    this.frozen = false;
  }

  update(delta: number): void {
    if (this.frozen) return;
    this.angle += delta * this.angularSpeed;
    this.camera.position.x = this.center.x + Math.sin(this.angle) * this.radius;
    this.camera.position.z = this.center.z + Math.cos(this.angle) * this.radius;
    this.camera.position.y = this.height;
    this.camera.lookAt(this.center);
  }
}
